import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  AssessmentFlowDto,
  AssessmentFlowReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import AssessmentFlowInline, { AssessmentFlowInlineProps } from "./AssessmentFlowInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: AssessmentFlowDto | AssessmentFlowReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<AssessmentFlowInlineProps>;
}

export default function AssessmentFlowLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.AssessmentFlowRead]}
      to={ROUTE_PATH.ASSESSMENT_FLOW_VIEW(entity?.id || entityId || "")}
      content={<AssessmentFlowInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
